import { render } from "./PageAddWizard.vue?vue&type=template&id=1db065fa"
import script from "./PageAddWizard.vue?vue&type=script&lang=js"
export * from "./PageAddWizard.vue?vue&type=script&lang=js"

import "./PageAddWizard.vue?vue&type=style&index=0&id=1db065fa&lang=scss"

import exportComponent from "/app/tmp/bambl/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__